import qs from 'qs';

import i18n from '@app/i18n';
import api from '@shared/api';

import {
    Taxpayer,
    TaxpayerAccountResponse,
    TaxpayerContractorsResponse,
    TaxpayerDeclarationPageRequest,
    TaxpayerDeclarationPageResponse,
    TaxpayerListResponse,
    TaxpayerPeriodBalanceResponse,
    TaxpayersRequest,
} from './types';

const PATH = 'tax-fiscal-data/taxpayers';
const FISCAL_PATH = 'tax-fiscal-data';
const ACCOUNTING_PATH = 'accounting';

const paramsSerializer = (params: unknown) => qs.stringify(params, {skipNulls: true});

export const fetchTaxpayers = async (payload: TaxpayersRequest) =>
    (
        await api.get<TaxpayerListResponse>(PATH, {
            params: payload,
            paramsSerializer,
        })
    ).data;

export const downloadTaxpayersExcel = async (payload: TaxpayersRequest) =>
    (
        await api.get<ArrayBuffer>(`${PATH}/excel`, {
            params: payload,
            paramsSerializer,
            responseType: 'arraybuffer',
            headers: {'Accept-Language': i18n.language},
        })
    ).data;

export const fetchTaxpayer = async (payload: {tin: string; period: string}) =>
    (
        await api.get<Taxpayer>(`${PATH}/${payload.tin}`, {
            params: {period: payload.period},
        })
    ).data;

export const fetchTaxpayerContractors = async (payload: {
    tin: string;
    period: string;
    page: number;
    limit: number;
    view: 'buyer' | 'seller';
    filter?: string;
    sortBy?: string;
    direction?: 'ASC' | 'DESC';
}) =>
    (
        await api.get<TaxpayerContractorsResponse>(`${FISCAL_PATH}/contractors`, {
            params: {
                period: payload.period,
                inn: payload.tin,
                page: payload.page,
                limit: payload.limit,
                [payload.view]: true,
                ...(payload.filter && {filter: payload.filter}),
                ...(payload.sortBy && payload.direction
                    ? {sortBy: payload.sortBy, direction: payload.direction}
                    : {}),
            },
            paramsSerializer,
        })
    ).data;

export const fetchTaxpayerYearBalance = async (payload: {tin: string; year: number}) =>
    (
        await api.get<TaxpayerPeriodBalanceResponse>(`${FISCAL_PATH}/getYearSaldo`, {
            params: payload,
            paramsSerializer,
        })
    ).data;

export const fetchTaxpayerAccount = async (payload: {tin: string; year: number; month: number}) =>
    (
        await api.get<TaxpayerAccountResponse>(`${ACCOUNTING_PATH}/api/v2/account/monthActivity`, {
            params: payload,
            paramsSerializer,
        })
    ).data;

export const fetchTaxpayerDeclarations = async (payload: TaxpayerDeclarationPageRequest) =>
    (
        await api.post<TaxpayerDeclarationPageResponse>(
            'invoice-api/api/v2/declarations/page',
            payload,
        )
    ).data;
